<div class="modal-overlay">
  <app-nada-spinner [size]="100" />
</div>
